import React, {useState, useEffect} from 'react'
import './list.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {db} from '../../../firebase'
import { collection, onSnapshot, query, orderBy, deleteDoc, doc, where } from "firebase/firestore";
import { Link } from 'react-router-dom'
import { DeleteOutline } from '@mui/icons-material'
import ConfirmBox from '../../../components/ConfirmBox'

const List = () => {

  const [ subData, setSubData ] = useState([])

  const [ data, setData ] = useState([])
   
  const [ isLoading, setIsLoading ] = useState(true)
  
  const [ open, setOpen ] = useState(false);
  
  const [ deleteId, setDelete ] = useState("");



  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

 
  useEffect(() => {
   
    
    //LISTEN REAL TIME
        const collectionRef = collection(db, "subscribers")

        const querySub = query(collectionRef, where('status', '==', 'active'), orderBy("timeStamp", "desc"))
    
        const unsub = onSnapshot(querySub, (snapShot) => {

          let list = [];

          snapShot.docs.forEach((doc) => {

            list.push({ id: doc.id, ...doc.data(), timeStamp: doc.data().timeStamp.toDate()})

          })

          setSubData(list)

          setIsLoading(false)

        }, 

          (error) => {

            console.log(error)

          }

        );
    
        return () => {
          unsub();
        }
    
    //END LISTEN REAL TIME    
    
      },[])



      function openDelete(id) {
      
          setOpen(true);
      
          setDelete(id);
          
      }
      
      
        
    console.log(data)
    
    
    const handleDelete = async() => {
    
      await deleteDoc(doc(db, "rewards", deleteId));
      
      setData(data.filter((item) => item.id !== deleteId))
  
      setOpen(false)
    
    }


  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        {/* <DataTable/> */}

        <div className='reviewTitle'>
          <h3 className='title'>Customers Reviews On each Outlet</h3>
        </div>

        <div className='reviewBody'>

        {isLoading ? <Spinner/> : 

          subData.map(row => {

          return (

          // <div className='reviewBody'>
              <div className='reviewSingle' key={row.id}>
                    <div className='reviewLeft'>
                      <div className='reviewPhoto'>
                      <img
                          src={row.files[0]}
                          alt="avatar"
                          className="itemimg"
                          style={{width:180, height:200}}
                          resizeMode="cover"
                      />
                      </div>
                      <div className='reviewDetails'>
                      <div className='details'>
                        <div className="name">{row.outletname} {row.outlet}</div>
                        <div className="telephone">{row.region} {row.area}</div>
                        <div className="email">Overall Rating</div>
                      </div>
                      <Link to={`/reviews/${row.id}`} key={row.id} className='reviewLink'>View Customers Reviews</Link>
                      </div>
                       
                    </div>

                  {/* <div onClick={() => openDelete(row.id)} style={{display:'flex', cursor:'pointer', width:40, height:40,backgroundColor:'lightgray', alignItems:'center', justifyContent:'center', borderRadius: '50%', position:'absolute', top:20, right:20}} className='reviewDelete'>
                    <DeleteOutline style={{color:'#eea1a1'}}/>
                  </div>  */}
                  
              </div>
          // </div>
          
          )

        })

        }

        </div>

      </div>

      <ConfirmBox
        open={open}
        closeDialog={() => setOpen(false)}
        // title={deleteData?.name}
        deleteFunction={handleDelete}
      />
    </div>
  )
}

export default List